import { styled } from "unikit";

const Wrapper = styled.View({
  px: 10,
  width: "100%",
});

export default Wrapper;
